import Stack from '@mui/material/Stack';
import React, { Fragment } from 'react';
import { Box, CircularProgress, Grid } from '@mui/material';
import { Styles } from '@t2c/shared-fe';
import InfiniteScroll from 'react-infinite-scroll-component';
import EmptyPage from '../../../../Common/EmptyPage';
import { CardTypeEnum, ContentType, EMPTY_PAGE_TEXT, extractDate, extractTime } from '../../../../utils';
import { AvatarCard } from '../../../../components/avatar-library/PrivateAvatarCard';
import { InfiniteData } from '@tanstack/react-query';
import { AvatarVideosResponse } from '../../../../services/creations/getAllAvatarCreatedVideos';

interface Props {
  allData: InfiniteData<AvatarVideosResponse>,
  isLoading: boolean,
  refetch: Function,
  fetchNextPage: any,
  hasNextPage: boolean,
  setSelectedIndex: any,
  selectedIndex: number | null,
}

export const TalkingFaceTab: React.FC<Props> = ({
  allData,
  isLoading,
  refetch: refetchData,
  fetchNextPage,
  hasNextPage,
  setSelectedIndex,
  selectedIndex,
}) => {
  return (
    <>
    {isLoading ? (
      <Stack sx={styles.loader}>
        <CircularProgress />
      </Stack> 
    ) : !(allData?.pages?.[0]?.data ?? []).length ? (
      <Box sx={styles.container}>
        <EmptyPage text={EMPTY_PAGE_TEXT.video} type={ContentType.Video} />
      </Box>
    ) : (
      <InfiniteScroll
        dataLength={
          allData?.pages?.reduce((acc, page) => acc + page.data.length, 0) || 0
        }
        next={fetchNextPage}
        hasMore={hasNextPage}
        loader={
          <Box p={2} textAlign={'center'}>
            <h2>loading...</h2>
          </Box>
        }
        style={{ overflow: 'visible' }}
        scrollableTarget='scrollableDiv'
      >
        <Grid container justifyContent={''} spacing={4}>
          {allData?.pages &&
            allData?.pages?.map((page, pageIndex) => (
              <Fragment key={pageIndex}>
                {(page?.data ?? []).map((data,index) => {
                  return (
                    <Grid item flex={1} xs={12} sm={4} key={data.id}>
                      <AvatarCard
                        avatarLogo={data?.avatar?.thumbnail}
                        avatarName={data.name}
                        status={data.status}
                        message="We hit a glitch in the matrix! Your video didn’t make it. Give it another shot! "
                        handleClick={() =>
                          {
                            if(data.status === 'Success') {
                              setSelectedIndex(index)
                            }
                          }
                        }
                        type={CardTypeEnum.LipsyncVideo}
                        date={extractDate(
                          data.updatedAt ? data.updatedAt : data.createdAt
                        )}
                        time={extractTime(
                          data.updatedAt ? data.updatedAt : data.createdAt
                        )}
                        creationId={data.id}
                        url={data.processedVideo}
                        refetchData={refetchData}
                        draftStatus={data.draftStatus}
                        draftMessage={'Draft'}
                        isActive={selectedIndex === index}
                      />
                    </Grid>
                  );
                })}
              </Fragment>
            ))}
        </Grid>
      </InfiniteScroll>
    )}
    </>
  );
};

const styles: Styles = {
  container: {
    overflow: 'auto',
    height: '300px'
  },
  noDataText: {
    width: '100%',
    textAlign: 'center',
    marginTop: 2,
    color: (theme) => theme.palette.text.secondary,
  },
  skeleton: {
    borderRadius: 2,
  },
  noDataFoundContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    height: 300,
    width: '100%',
  },
};
